import NetworkApi from './networkApi';
import paths from './path';

const persistSession = ({ token, refreshToken, type, permissions }) => {
  try {
    if (token) localStorage.setItem('token', token);
    if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
    if (type) localStorage.setItem('type', type);
    if (permissions) localStorage.setItem('permissions', JSON.stringify(permissions));
  } catch {
    return;
  }
};

export const login = async (body) => {
  const res = await NetworkApi.post(paths.LoginUrl, body);

  if (res.status >= 200 && res.status < 300 && res?.data) {
    const { token, refreshToken, user } = res.data;
    const { type, permissions } = user;
    persistSession({ token, refreshToken, type, permissions });
    return res.data;
  }

  const errorMessage = res?.data?.message || 'Login failed';
  const error = new Error(errorMessage);
  error.response = res;
  throw error;
};

export const changePassword = async (body) => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    Authorization: `${localStorage.getItem('token')}`,
  };

  return NetworkApi.post(paths.changePasswordUrl, body, headers);
};

export const changeAppLanguage = async (body) => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    Authorization: `${localStorage.getItem('token')}`,
  };

  return NetworkApi.patch(paths.updateLanguage, body, headers);
};

export const getUserConfirm = async (body) => {
  const param = new URLSearchParams(window.location.search);
  const inviteToken = param.get('inviteToken');

  return NetworkApi.post(paths.confirmUser(inviteToken), body);
};
